"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.planFetchByIdReducer = exports.planFetchByApplicationReducer = exports.planUpdateReducer = exports.planCreateReducer = exports.planFetchReducer = exports.planFetchByIdSlice = exports.planFetchByApplicationSlice = exports.planUpdateSlice = exports.planCreateSlice = exports.planFetchSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const planAction_1 = require("./planAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchPlanByApplicationInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchByIdInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.planFetchSlice = (0, toolkit_1.createSlice)({
    name: 'plan/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(planAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(planAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(planAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.planCreateSlice = (0, toolkit_1.createSlice)({
    name: 'plan/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(planAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(planAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(planAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.planUpdateSlice = (0, toolkit_1.createSlice)({
    name: 'plan/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(planAction_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(planAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(planAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.planFetchByApplicationSlice = (0, toolkit_1.createSlice)({
    name: 'plan/fetchByApplication',
    initialState: fetchPlanByApplicationInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(planAction_1.fetchByApplication.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(planAction_1.fetchByApplication.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(planAction_1.fetchByApplication.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.planFetchByIdSlice = (0, toolkit_1.createSlice)({
    name: 'plan/fetchById',
    initialState: fetchByIdInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(planAction_1.fetchById.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(planAction_1.fetchById.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(planAction_1.fetchById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.planFetchReducer = exports.planFetchSlice.reducer;
exports.planCreateReducer = exports.planCreateSlice.reducer;
exports.planUpdateReducer = exports.planUpdateSlice.reducer;
exports.planFetchByApplicationReducer = exports.planFetchByApplicationSlice.reducer;
exports.planFetchByIdReducer = exports.planFetchByIdSlice.reducer;
